<style>
.custom-date-input .v-field {
  min-height: 45px !important; /* igual que el text-field */
  height: 45px !important;
  align-items: center !important; /* centra verticalmente */
}

.custom-date-input .v-field__input {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
<template>
  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 15px; font-weight: 600; border-bottom: 1px solid">
      {{ "SOC-" + code.toString().padStart(7, "0") }} - Datos Generales
    </h2>

    <div class="d-flex flex-wrap ga-3">
      <div class="w-in">
        <label><b></b>Tipo Solicitud:</label>

        <v-autocomplete
          pa-1
          ma-0
          hide-details
          v-model="tipoSol"
          autocomplete="off"
          :items="lstTipoSolicitud"
          variant="solo"
          item-title="id"
          item-value="nombre"
          @update:modelValue="cambioRetBodega"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Fecha Solicitud:</label>

        <v-text-field
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          v-model="date"
          type="date"
          variant="solo"
          color="primary"
          disabled
          required
        />
      </div>

      <!-- <div class="w-in" v-if="tipoSol.id == 'Rendicion'">
        <label>Fecha Liberación:</label>

        <v-text-field
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          v-model="fechaLiberacion"
          type="date"
          variant="solo"
          color="primary"
        />
      </div> -->

      <div class="w-in">
        <label>Ingresado Por:</label>

        <v-text-field
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          v-model="solPorNombre"
          readonly
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label> Rut Ingresado Por: </label>
        <v-text-field
          variant="solo"
          pa-1
          autocomplete="off"
          ma-0
          v-model="solPorId"
          readonly
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Empresa:</label>

        <v-autocomplete
          v-model="empresaSel"
          pa-1
          hide-details
          ma-0
          :items="lstEmpresas"
          autocomplete="off"
          variant="solo"
          item-title="displayName"
          item-value="id"
          @update:modelValue="selectCompany"
          clearable
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Departamento:</label>

        <v-autocomplete
          v-model="departamentoSel"
          pa-1
          ma-0
          autocomplete="off"
          hide-details
          :items="lstDepartamento"
          variant="solo"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="!isIngresoRespel(tipoSol.id)">
        <label>Solicitante:</label>

        <v-autocomplete
          v-model="solicitanteSel"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          autocomplete="off"
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          clearable
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Retiro Bodega' || tipoSol.id == 'Retiro RESPEL'">
        <label>Cod. Bod:</label>

        <v-autocomplete
          variant="solo"
          :items="lstBodegas"
          hide-details
          pa-1
          ma-0
          autocomplete="off"
          clearable
          item-title="codeDisplayName"
          item-value="id"
          v-model="codigoBodega"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Retiro RESPEL'">
        <label>N° Guía despacho:</label>

        <v-text-field
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          v-model="codigoDespacho"
          hide-details
          readonly
        >
        </v-text-field>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Compra'">
        <label>Proveedor:</label>

        <v-autocomplete
          v-model="vendorSel"
          :items="lstVendors"
          variant="solo"
          item-title="numberDisplayName"
          item-value="id"
          autocomplete="off"
          clearable
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Compra'">
        <label>Comprador:</label>

        <v-autocomplete
          v-model="compradorSel"
          :items="lstCompradores"
          variant="solo"
          item-title="name"
          item-value="code"
          clearable
          hide-details
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Compra'">
        <label>¿La solicitud es regularización?</label>

        <v-autocomplete
          v-model="regSel"
          :items="lstRegularizacion"
          variant="solo"
          item-title="nombre"
          item-value="id"
          hide-details
          autocomplete="off"
          @update:modelValue="cambioRegJustificacion"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol.id == 'Compra' && regSel?.id == 'Si'">
        <label>Justificación regularización</label>

        <v-autocomplete
          v-model="justSel"
          :items="lstJustificacion"
          variant="solo"
          item-title="nombre"
          item-value="id"
          hide-details
          autocomplete="off"
          @update:modelValue="cambioJustificacion"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipoSol.id == 'Compra' && regSel?.id == 'Si' && justSel?.id == 5"
      >
        <label>Justificación Autorizada Por:</label>

        <v-autocomplete
          v-model="autorizadorSel"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipoSol.id == 'Compra' && regSel?.id == 'Si' && justSel?.id == 7"
      >
        <label>Descripción Otro:</label>

        <v-textarea
          variant="solo"
          pa-1
          ma-0
          v-model="descripOtro"
          hide-details
          autocomplete="off"
        >
        </v-textarea>
      </div>

      <div class="w-in">
        <label>Observación:</label>

        <v-textarea
          variant="solo"
          pa-1
          ma-0
          v-model="obs"
          hide-details
          autocomplete="off"
        >
        </v-textarea>
      </div>

      <div v-if="adjuntos.length > 0" class="w-100">
        <label>{{ adjuntos.length }} Archivos Adjuntos:</label>

        <div class="text-center d-flex flex-wrap">
          <div
            v-for="(adj, index) in adjuntos"
            :key="index"
            style="align-items: center"
          >
            <v-tooltip :text="adj.nombre">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="ma-2"
                  style="
                    height: 55px;
                    background-color: #a61a2f;
                    color: white;
                    border-radius: 11px;
                  "
                  @click="bajarAdjunto(sliceString(adj.url))"
                >
                  <v-icon size="x-large">{{ setIcon(adj.nombre) }}</v-icon>
                  <div>Archivo {{ index + 1 }}</div>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>

    <h2 style="font-weight: 600; margin-top: 10px">Detalle Solicitud</h2>

    <div class="w-in">
      <v-combobox
        style="font-size: 16px; margin-bottom: 10px"
        pa-1
        ref="mySearch"
        :loading="loading"
        :items="lstItems"
        autocomplete="off"
        :hide-no-data="false"
        v-model="item"
        item-title="numberDisplayName"
        item-value="id"
        variant="solo"
        dense
        hide-details
        clearable
        label="Busca un Material/Servicio"
        no-data-text="No se encontro Material/Servicio"
        @update:search="BuscarMaterial"
        return-object
      >
      </v-combobox>
    </div>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Compra' && !isViveres"
      :headers="headers"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.precio"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstProyectos"
          variant="outlined"
          density="compact"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaLimite"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.mesServicio="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstMesServicio"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.mesServicio"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Compra' && isViveres"
      :headers="headersTripulanteViveres"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.precio"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstProyectos"
          variant="outlined"
          density="compact"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.mesServicio="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstMesServicio"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.mesServicio"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.tripulanteId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTripulantes"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="displayName"
          item-value="id"
          :return-object="false"
          v-model="item.tripulanteId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.turnoId="{ item }">
        <v-autocomplete
          v-model="item.turnoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstTurnos"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.fechaCompra="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaCompra"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.fechaTermino="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaTermino"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaLimite"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Retiro Bodega'"
      :headers="headersRetiro"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          @keypress="filterNumber($event)"
          v-model="item.cantidad"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          autocomplete="off"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          ma-0
          :items="lstProyectos"
          variant="outlined"
          item-title="codeDisplayName"
          item-value="id"
          autocomplete="off"
          density="compact"
          clearable
          :return-object="false"
          hide-details
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.numSerie="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          v-model="item.numSerie"
        >
        </v-text-field>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol.id === 'Rendicion'"
      :headers="headersRendicion"
      :items="lstDetalle"
    >
      <template v-slot:item.tipoDoc="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTipoDoc"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="nombre"
          autocomplete="off"
          item-value="id"
          :return-object="false"
          v-model="item.tipoDoc"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.nroDoc="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.nroDoc"
          variant="outlined"
          color="primary"
          autocomplete="off"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.fechaDoc="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaDoc"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.Material="{ item }">
        {{ item.material }}
      </template>

      <template v-slot:item.proveedorId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstVendors"
          density="compact"
          autocomplete="off"
          pa-1
          ma-0
          hide-details
          item-title="numberDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.proveedorId"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.descGasto="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.descGasto"
          variant="outlined"
          autocomplete="off"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.monto="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          v-model="item.monto"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="rendicionTotal"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          autocomplete="off"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          ma-0
          :items="lstProyectos"
          variant="outlined"
          item-title="codeDisplayName"
          item-value="id"
          autocomplete="off"
          density="compact"
          clearable
          :return-object="false"
          hide-details
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="isRespelTipo(tipoSol.id)"
      :headers="computedHeadersResiduo"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.unidad="{ item }">
        <v-autocomplete
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          :items="lstUnidadesResiduo"
          v-model="item.unidad"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.tipoResiduo="{ item }">
        <v-autocomplete
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          :items="lstTiposResiduo"
          v-model="item.tipoResiduo"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <div
      v-if="tipoSol.id != 'Retiro Bodega'"
      style="
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;
      "
    >
      Total: {{ formatMoney(total) }}
      <!-- Total: {{ total }} -->
    </div>

    <div class="d-flex flex-wrap">
      <div class="w-in">
        <v-file-input
          pa-1
          ma-0
          v-model="selectedFiles"
          multiple
          autocomplete="off"
          label="Selecciona archivos"
          variant="solo"
          @update:modelValue="addFiles"
        >
        </v-file-input>

        <v-chip closable v-for="f in file" v-bind:key="f.name">
          {{ f.name }}
        </v-chip>
      </div>
      <div class="w-69 d-flex mt-3" style="justify-content: end">
        <v-btn
          style="
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-right: 5px;
            display: flex;
          "
          density="default"
          :loading="isLoading"
          :disabled="isLoading"
          v-on:click="guardarSolicitud()"
          >Guardar</v-btn
        >

        <v-btn
          style="
            background-color: #10510e;
            padding: 15px;
            border-radius: 15px;
            color: white;
            display: flex;
          "
          density="default"
          :loading="isLoading"
          :disabled="isLoading"
          v-on:click="crearSolicitud()"
          >Crear Solicitud</v-btn
        >
      </div>
    </div>
  </div>

  <v-dialog v-model="dialogDelete" persistent width="auto">
    <v-card>
      <v-card-title class="text-h5"> Borrar Item </v-card-title>
      <v-card-text>
        Esta seguro que desea item el material `{{
          itemToDelete.codigoMaterial
        }}` ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogDelete = false">No</v-btn>
        <v-btn color="primary" @click="deleteMaterial(itemToDelete)">Si</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
  >
    <div class="text-center">
      <v-progress-circular
        color="#a61a2f"
        size="60"
        :width="5"
        indeterminate
      ></v-progress-circular>
      <p style="color: white; margin-top: 20px; font-size: 16px; font-weight: 500;">
        {{ tipoSol?.id === "Retiro RESPEL" || tipoSol?.id === "Ingreso RESPEL" 
          ? "Creando solicitud RESPEL..." 
          : "Procesando solicitud..." }}
      </p>
    </div>
  </v-overlay>

  <v-overlay
    :model-value="isLoadingEmail"
    class="align-center justify-center"
    persistent
  >
    <div>
      <v-progress-circular
        color="#a61a2f"
        size="50"
        :width="5"
        indeterminate
      ></v-progress-circular>

      <div
        style="
          margin-top: 10px;
          margin-left: -50px;
          font-size: 15px;

          color: #000000;
        "
      >
        <b>Validando Identidad</b>
      </div>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import axios from "axios";
import { useCookies } from "vue3-cookies";
import { useRouter, useRoute } from "vue-router";
import swal from "sweetalert2";
import currency from "currency.js";
import { translateBcError } from "@/utils/errorTranslator";
import { isIngresoRespel, isRespelTipo, normalizeTipoSolicitud } from "@/utils/tipoSolicitudHelpers";

import type { SolicitudCompra } from "../types/solicitudCompra";
import type { Company } from "../types/company";
import type { Departamento } from "../types/departamento";
import type { Vendors } from "../types/vendors";
import type { Empleado } from "../types/empleado";
import type { Adjunto } from "../types/adjunto";
import type { Location } from "../types/location";
import type { SolicitudDetalle } from "../types/solicitudDetalle";
import type { Rol } from "../types/rol";
import type { Proyecto } from "../types/proyecto";
import type { TipoSolicitud } from "../types/tipoSolicitud";
import type { Item } from "../types/item";
import type { SolicitudEncabezado } from "../types/SolicitudEncabezado";
import type { TipoDocumento } from "../types/tipoDocumento";
import type { Regularizacion } from "../types/regularizacion";
import type { Justificacion } from "../types/justificacion";
import type { Comprador } from "../types/comprador";
import type { MesServicio } from "../types/messervicio";
import type { TienePresup } from "../types/tienePresup";
// import type { Presupuesto } from "../types/presupuesto";

import useDepartamentos from "../composables/useDepartamento";
import useCeco from "../composables/useCeco";
import useVendors from "../composables/useVendors";
import useComprador from "../composables/useComprador";
import useBodegas from "../composables/useBodega";
import useProyecto from "../composables/useProyecto";
import useSolicitante from "../composables/useSolicitante";
import useAuxNdoc from "../composables/useAuxNdoc";
// import useConcepto from "../composables/useConcepto";
// import usePresupuesto from "../composables/usePresupuesto";
import useTripulante from "../composables/useTripulante";
import useTurno from "../composables/useTurno";
import useEmpresa from "../composables/useEmpresa";

const { cookies } = useCookies();
const store = useStore(key);
const router = useRouter();
const route = useRoute();

const idSol = computed(() => route.query.id as string | undefined);

const { getDepartamentos, lstDepartamento } = useDepartamentos();
const { getCeco, lstCeco } = useCeco();
const { getVendors, lstVendors } = useVendors();
const { getCompradores, lstCompradores } = useComprador();
const { getBodegas, getBodegasResiduo, lstBodegas } = useBodegas();
const { getProyectos, lstProyectos } = useProyecto();
const { getSolicitantes, lstSolicitantes } = useSolicitante();
const { getAuxNdoc, lstAuxNdoc } = useAuxNdoc();
// const { getConceptos, lstConceptos } = useConcepto();
// const { getPresupuesto, disminuirPresupuesto } = usePresupuesto();
const { getTripulantes, lstTripulantes } = useTripulante();
const { getTurnos, lstTurnos } = useTurno();
const { getCompanies, lstEmpresas } = useEmpresa();

let isLoading: Ref<boolean> = ref(true);
let isLoadingEmail: Ref<boolean> = ref(false);

let lstTipoSolicitud: TipoSolicitud[] = [
  { id: "Compra", nombre: "Compra" },
  { id: "Retiro Bodega", nombre: "Retiro Bodega" },
  { id: "Rendicion", nombre: "Rendicion" },
];

let lstTipoDoc: TipoDocumento[] = [
  { id: "Sin Documento", nombre: "Sin Documento" },
  { id: "Boleta", nombre: "Boleta" },
  { id: "Factura", nombre: "Factura" },
  { id: "Vale", nombre: "Vale" },
  { id: "B. Honorarios", nombre: "B. Honorarios" },
];

let tipoSol: Ref<TipoSolicitud> = ref(lstTipoSolicitud[0]);
// let lstEmpresas: Ref<Company[]> = ref([]);
let solPorId: Ref<string> = ref("");
let solPorNombre: Ref<string> = ref("");

let empresaSel: Ref<Company | null> = ref(null);
let departamentoSel: Ref<Departamento | null> = ref(null);
let vendorSel: Ref<Vendors | null> = ref(null);
let compradorSel: Ref<Comprador | null> = ref(null);
let proyectoSel: Ref<Proyecto | null> = ref(null);
let solicitanteSel: Ref<Empleado | null> = ref(null);

let codigoBodega: Ref<Location | null> = ref(null);
let idSolicitud: string = "";
let date: Ref<string> = ref("");
let fechaLiberacion: Ref<string | null> = ref(null);
let code: Ref<number> = ref(0);
let obs: Ref<string> = ref("");
let codigoDespacho: Ref<string> = ref("");
let estado: Ref<string> = ref("");
let tipo: Ref<string> = ref("");
let solId: Ref<string> = ref("");
let solNombre: Ref<string> = ref("");
let dialogCerrar: Ref<boolean> = ref(false);
const lstDetalle: SolicitudDetalle[] = reactive([]);
let adjuntos: Ref<Adjunto[]> = ref([]);
let total: Ref<number> = ref(0);
let detContador: number = 1;
let lstItems: Ref<Item[]> = ref([]);
let item: Ref<Item | string | null> = ref(null);
let loading: boolean = false;
let selectedFiles: Ref<File[]> = ref([]);
let file: Ref<File[]> = ref([]);
let dialogDelete: Ref<boolean> = ref(false);
let itemToDelete: SolicitudDetalle = {};
let codBodega: string = "";
let usuario: Ref<Empleado | null> = ref(null);
let autorizador: Ref<string> = ref("");
let regSel: Ref<Regularizacion | null> = ref(null);
let justSel: Ref<Justificacion | null> = ref(null);
let autorizadorSel: Ref<Empleado | null> = ref(null);
let descripOtro: Ref<string | null> = ref(null);
let isViveres: Ref<boolean> = ref(false);
let esComprador: Ref<boolean> = ref(false);

let headers: any = [
  { title: "", key: "isSelected", width: "25px" },
  { title: "Id", key: "id", align: "center", width: "50px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "100px",
  },
  { title: "UN", key: "unidad", align: "center", width: "90px" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "180px!important",
  },
  { title: "Q", key: "cantidad", align: "center", width: "100px" },
  { title: "Precio", key: "precio", align: "center", width: "100px" },
  { title: "Total", key: "total", align: "center", width: "100px" },
  { title: "Ceco", key: "cecoId", align: "start", width: "150px" },
  { title: "Proyecto", key: "proyectoId", align: "center", width: "150px" },
  { title: "Bodega", key: "codigoBodega", align: "center", width: "100px" },
  {
    title: "Ped. Compra",
    key: "pedidoCompra",
    align: "center",
    width: "100px",
  },
  {
    title: "OT Mantención",
    key: "otMantencion",
    align: "center",
    width: "50px",
  },
  {
    title: "Mes servicio",
    key: "mesServicio",
    align: "center",
    width: "150px!important",
  },
  /*{
    title: "Concepto",
    key: "conceptoName",
    align: "center",
    width: "150px!important",
  },*/
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersTripulanteViveres: any = [
  { title: "", key: "isSelected", width: "25px" },
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Cod",
    key: "codigoMaterial",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "180px!important",
  },
  { title: "Precio", key: "precio", align: "center", width: "150px!important" },
  { title: "Total", key: "total", align: "center", width: "100px!important" },
  { title: "Ceco", key: "cecoId", align: "center", width: "200px!important" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "250px!important",
  },
  {
    title: "Tripulante",
    key: "tripulanteId",
    align: "center",
    width: "225px!important",
  },
  {
    title: "Turno",
    key: "turnoId",
    align: "center",
    width: "225px!important",
  },
  {
    title: "Fecha Compra",
    key: "fechaCompra",
    align: "center",
    width: "220px!important",
  },
  {
    title: "Fecha Término",
    key: "fechaTermino",
    align: "center",
    width: "220px!important",
  },
  // {
  //   title: "Mes servicio",
  //   key: "mesServicio",
  //   align: "center",
  //   width: "150px!important",
  // },
  /*{
    title: "Tiene Presupuesto",
    key: "tienePresup",
    align: "center",
    width: "50px!important",
  },
  {
    title: "Concepto",
    key: "concepto",
    align: "center",
    width: "300px!important",
  },*/
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersRetiro: any = [
  { title: "Id", key: "id", width: "25px" },
  { title: "Tipo", key: "tipo", align: "start", width: "100px" },
  {
    title: "Cod",
    key: "codigoMaterial",
    align: "center",
    width: "120px",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "start",
    width: "150px",
  },
  {
    title: "Inventario",
    key: "inventario",
    align: "center",
    width: "50px",
  },
  { title: "N° Serie", key: "numSerie", align: "center", width: "150px" },
  { title: "UN", key: "unidad", align: "center", width: "50px" },
  { title: "Cantidad", key: "cantidad", align: "center", width: "100px" },
  { title: "Ceco", key: "cecoId", align: "center", width: "250px" },
  { title: "Proyecto", key: "proyectoId", align: "center", width: "150px" },
  {
    title: "OT Mantención",
    key: "otMantencion",
    align: "center",
    width: "150px",
  },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersRendicion: any = [
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Tipo Docto",
    key: "tipoDoc",
    align: "center",
    width: "220px",
  },
  { title: "N° Docto", key: "nroDoc", align: "center", width: "100px" },
  {
    title: "Fecha Docto",
    key: "fechaDoc",
    align: "center",
    width: "200px",
  },
  {
    title: "Proveedor",
    key: "proveedorId",
    align: "center",
    width: "200px",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "150px",
  },
  {
    title: "Descripción del Gasto",
    key: "descGasto",
    align: "center",
    width: "150px",
  },
  { title: "Ceco", key: "cecoId", align: "center", width: "250px" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "250px",
  },
  { title: "Monto", key: "monto", align: "center", width: "150px" },
  {
    title: "OT Mantención",
    key: "otMantencion",
    align: "center",
    width: "150px",
  },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersResiduo: any = [
  { title: "Id", key: "id", align: "center", width: "50px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  { title: "Material/Servicio", key: "material", align: "center", width: "300px" },
  { title: "UN", key: "unidad", align: "center", width: "120px" },
  { title: "Cantidad", key: "cantidad", align: "center", width: "120px!important" },
  { title: "Ceco", key: "cecoId", align: "center", width: "200px!important" },
  { title: "Bodega", key: "codigoBodega", align: "center", width: "200px!important" },
  //{ title: "Tipo Residuo", key: "tipoResiduo", align: "center", width: "200px!important" },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let computedHeadersResiduo = computed(() => {
  if (tipoSol.value.id === "Retiro RESPEL") {
    return headersResiduo.filter((h: any) => h.key !== "codigoBodega");
  }
  return headersResiduo;
});

let lstRegularizacion: Regularizacion[] = [
  { id: "Si", nombre: "Si" },
  { id: "No", nombre: "No" },
];

const lstTiposResiduo: string[] = [
  "Industrial Peligroso",
  "Industrial No Peligroso",
  "Riles",
  "Domicilarios",
];

const lstUnidadesResiduo: string[] = ["lts", "tin", "un", "plt", "kg", "m3"];

let lstJustificacion: Justificacion[] = [
  { id: 1, nombre: "Adicionales" },
  { id: 2, nombre: "No planificado" },
  { id: 3, nombre: "Urgencia" },
  { id: 4, nombre: "Corrección tipo cambio" },
  { id: 5, nombre: "Regularización Autorizada por" },
  { id: 6, nombre: "Servicio recurrente, trabaja sin SOC" },
  { id: 7, nombre: "Otro justificar" },
];

let lstMesServicio: MesServicio[] = [];

/*let lstMesServicio: MesServicio[] = [
  { id: "2024-12", nombre: "2024-12" },
  { id: "2025-01", nombre: "2025-01" },
  { id: "2025-02", nombre: "2025-02" },
  { id: "2025-03", nombre: "2025-03" },
  { id: "2025-04", nombre: "2025-04" },
  { id: "2025-05", nombre: "2025-05" },
  { id: "2025-06", nombre: "2025-06" },
  { id: "2025-07", nombre: "2025-07" },
  { id: "2025-08", nombre: "2025-08" },
  { id: "2025-09", nombre: "2025-09" },
  { id: "2025-10", nombre: "2025-10" },
  { id: "2025-11", nombre: "2025-11" },
  { id: "2025-12", nombre: "2025-12" },
];*/

// let lstTienePresup: TienePresup[] = [
//   { id: true, nombre: "Si" },
//   { id: false, nombre: "No" },
// ];

onMounted(async () => {
  store.state.titulo = "Editar Solicitud";

  getSolicitudCompra();
      const diciembreActual = new Date(new Date().getFullYear(), 11, 1); // mes 11 = diciembre
    lstMesServicio = generarMesesServicio(13, diciembreActual);
});

const openDatePicker = (e: Event) => {
  // El evento viene del wrapper del text-field
  const root = e.currentTarget as HTMLElement | null;
  const input = root?.querySelector?.('input[type="date"]') as
    | HTMLInputElement
    | undefined;

  if (input?.showPicker) {
    input.showPicker(); // Chrome/Edge/Safari modernos
  } else {
    input?.focus(); // Fallback (p.ej. Firefox)
  }
};

async function obtenerEmpleado(email: string) {
  try {
    isLoading.value = true;

    await axios
      .get(store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email, {
        headers: {},
      })
      .then(async (response) => {
        if (response.status == 200) {
          usuario.value = response.data;
          autorizador.value = response.data.rut;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function BuscarMaterial() {
  if (empresaSel.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar una empresa",
      showConfirmButton: true,
    });

    item.value = null;
    return;
  }

  if (tipoSol.value.id == "Retiro Bodega" && codigoBodega.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar una bodega",
      showConfirmButton: true,
    });

    item.value = null;
    return;
  }

  let det: SolicitudDetalle = {};

  if (typeof item.value === "string" || item.value instanceof String) {
    loading = true;

    let url: string =
      store.state.url +
      "api/Item/BuscadorItem?item=" +
      item.value +
      "&companyId=" +
      empresaSel.value.id;

    if (tipoSol.value.id == "Retiro Bodega") {
      url =
        store.state.url +
        "api/Item/BuscadorItemRetiro?item=" +
        item.value +
        "&companyId=" +
        empresaSel.value.id +
        "&location=" +
        codigoBodega.value?.code;
    }

    if (isRespelTipo(tipoSol.value.id)) {
      url =
        store.state.url +
        "api/Item/BuscadorItemResiduo?item=" +
        item.value +
        "&companyId=" +
        empresaSel.value.id;
    }

    if (item.value != null && new String(item.value).length > 2) {
      axios
        .get(url, {
          headers: {},
        })
        .then((response) => {
          if (response.status == 200) {
            lstItems.value = response.data;
            loading = false;
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
      // .finally(() => (loading = false));
    }
  } else {
    try {
      if (item.value != null) {
        if (typeof item.value == "string" || item.value instanceof String) {
          return;
        }

        if (tipoSol.value.id == "Rendicion") {
          det = {
            idItem: item.value.id,
            id: detContador,
            encabezadoId: idSolicitud,
            codigoMaterial: item.value.number,
            material: item.value.displayName,
            retiroBodega: false,
            monto: null,
            otMantencion: null,
            tipo: item.value.itemCategoryCode,
            generalProductPostingGroupCode:
              item.value.generalProductPostingGroupCode,
            cantidad: item.value.type == "Service" ? 1 : null,
          };
        } else {
          if (tipoSol.value.id == "Retiro Bodega") {
            det = {
              idItem: item.value.id,
              id: detContador,
              tipo: item.value.itemCategoryCode,
              encabezadoId: idSolicitud,
              codigoMaterial: item.value.number,
              material: item.value.displayName,
              unidad: item.value.baseUnitOfMeasureCode,
              cantidad: item.value.type == "Service" ? 1 : null,
              precio: null,
              total: 0,
              retiroBodega: true,
              otMantencion: null,
              inventario: item.value.remainingQuantity || 0,
            };
          }

          if (tipoSol.value.id == "Compra") {
            det = {
              idItem: item.value.id,
              id: detContador,
              tipo: item.value.itemCategoryCode,
              encabezadoId: idSolicitud,
              codigoMaterial: item.value.number,
              material: item.value.displayName,
              unidad: item.value.baseUnitOfMeasureCode,
              cantidad: item.value.type == "Service" ? 1 : null,
              precio: null,
              total: 0,
              otMantencion: null,
            };

            if (
              item.value.number == "SER-410102" &&
              (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
                empresaSel.value.name == "19 - TMO Acuicola S.A" ||
                empresaSel.value.name == "25 Consorcio De Proyectos Marí")
            ) {
              isViveres.value = true;
              det.cantidad = 1;
            } else {
              isViveres.value = false;
              det.cantidad = item.value.type == "Service" ? 1 : null;
            }
          }

          if (isRespelTipo(tipoSol.value.id)) {
            det = {
              idItem: item.value.id,
              id: detContador,
              tipo: item.value.itemCategoryCode,
              encabezadoId: idSolicitud,
              codigoMaterial: item.value.number,
              material: item.value.displayName,
              unidad: item.value.baseUnitOfMeasureCode,
              cantidad: null,
              tipoResiduo: null,
              cecoId: null,
              codigoBodega: null,
              cecoName: null,
              bodegaName: null,
            };
          }
        }

        if (det != null && lstDetalle != null) {
          if (
            tipoSol.value.id == "Compra" &&
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            lstDetalle.find((d) => d.codigoMaterial == "SER-410102") != null &&
            item.value.number != "SER-410102"
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Si ya agrego el item de Viveres, no puede agregar otro diferente",
              showConfirmButton: true,
            });

            item.value = null;
            isViveres.value = true;
            return;
          }

          if (
            tipoSol.value.id == "Compra" &&
            lstDetalle.find((d) => d.codigoMaterial != "SER-410102") != null &&
            item.value.number == "SER-410102"
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Si ya agrego otro item diferente a Viveres, no puede agregar Viveres",
              showConfirmButton: true,
            });

            item.value = null;
            isViveres.value = false;
            return;
          }

          lstDetalle.push(det);

          item.value = null;
          detContador++;
        }

        lstItems.value = [];
      }
    } catch (error) {
      console.log(error);
    }
  }
}

function getSolicitudCompra() {
  try {
    axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetSolicitudCompra?solicitudId=" +
          idSol.value //route.params.solicitudId
      )
      .then(async (response) => {
        if (response.status == 200) {
          var solicitud = response.data;

          // console.log(solicitud);

          const normalizedTipo = normalizeTipoSolicitud(solicitud.encabezado.tipoSolicitudId || "");

          let validarUsuario = await verificarUsuario(
            normalizedTipo,
            solicitud.encabezado.departamentoId,
            solicitud.encabezado.solicitantePorId,
            solicitud.encabezado.solicitanteId
          );

          if (!validarUsuario) {
            swal.fire({
              title: "Error",
              text: "No tiene permisos para ver esta solicitud",
              icon: "error",
              confirmButtonText: "Aceptar",
            });

            router.push({ name: "BuscaSolicitud" });
            return;
          }

          idSolicitud = solicitud.encabezado.id;
          tipoSol.value.id = normalizedTipo;
          date.value = solicitud.encabezado.fechaSolicitud.substr(0, 10);
          fechaLiberacion.value = solicitud.encabezado.fechaLiberacion ? solicitud.encabezado.fechaLiberacion.substr(0, 10) : null;
          solPorId.value = solicitud.encabezado.solicitantePorId;
          solPorNombre.value = solicitud.encabezado.solicitantePorNombre;
          solId.value = solicitud.encabezado.solicitanteId;
          solNombre.value = solicitud.encabezado.solicitanteNombre;
          code.value = solicitud.encabezado.code;

          await getCompanies(solPorId.value, normalizedTipo);

          if (solicitud.encabezado.companyId != null) {
            empresaSel.value = lstEmpresas.value.find(
              (r) => r.id == solicitud.encabezado.companyId
            ) as Company;
          }

          if (empresaSel.value != null) {
            localStorage.setItem("empresa", JSON.stringify(empresaSel.value));

            await getDepartamentos(empresaSel.value.id, solPorId.value);
            await getCeco(empresaSel.value.id);
            if (isRespelTipo(normalizedTipo)) {
              await getBodegasResiduo(empresaSel.value.id);
            } else {
              await getBodegas(empresaSel.value.id);
            }
            await getVendors(empresaSel.value.id);
            await getProyectos(empresaSel.value.id, solPorId.value);
            await getCompradores(empresaSel.value.id);
            await getAuxNdoc(empresaSel.value.id);
            //await getConceptos();

            if (
              empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí"
            ) {
              await getTripulantes(empresaSel.value.id);
              await getTurnos(empresaSel.value.id);
            }
          }

          await getSolicitantes();

          if (cookies.get("username") != "") {
            obtenerEmpleado(cookies.get("username"));
            // obtenerEmpleado("truiz@oxxeanchile.cl");

            await obtenerTiposSolicitud(solPorId.value, normalizedTipo);
          }

          if (solicitud.encabezado.departamentoId != null) {
            departamentoSel.value = lstDepartamento.value.find(
              (d) => d.id == solicitud.encabezado.departamentoId
            ) as Departamento;
          }

          solicitanteSel.value = lstSolicitantes.value.find(
            (s) => s.rut == solicitud.encabezado.solicitanteId
          ) as Empleado;

          obs.value = solicitud.encabezado.observacion;
          adjuntos.value = (await getFiles(idSolicitud)) || [];

          vendorSel.value = lstVendors.value.find(
            (v) => v.number == solicitud.encabezado.vendorId
          ) as Vendors;

          estado.value = solicitud.encabezado.estado;
          tipo.value = normalizedTipo;

          if (solicitud.encabezado.proyectoId != null) {
            proyectoSel.value = lstProyectos.value.find(
              (p) => p.id == solicitud.encabezado.proyectoId
            ) as Proyecto;
          }

          if (tipo.value == "Retiro Bodega") {
            // codigoDes = solicitud.encabezado.codigoDespacho;
            codigoBodega.value = lstBodegas.value.find(
              (b) => b.id == solicitud.encabezado.codigoBodega
            ) || { id: solicitud.encabezado.codigoBodega, codeDisplayName: solicitud.encabezado.codigoBodega } as any;
          }

          if (tipo.value == "Retiro RESPEL" || tipo.value == "Ingreso RESPEL") {
            tipoSol.value = { id: tipo.value, nombre: tipo.value };
            codigoDespacho.value = solicitud.encabezado.codigoDespacho || "";
            codigoBodega.value = lstBodegas.value.find(
              (b) => b.id == solicitud.encabezado.codigoBodega
            ) || ({ id: solicitud.encabezado.codigoBodega, codeDisplayName: solicitud.encabezado.codigoBodega } as any);
          }

          if (tipo.value == "Compra") {
            codigoBodega.value = lstBodegas.value.find(
              (b) => b.id == solicitud.encabezado.codigoBodega
            ) as Location;

            compradorSel.value = lstCompradores.value.find(
              (c) => c.code == solicitud.encabezado.comprador
            ) as Comprador;

            if (solicitud.encabezado.solRegularizacion) {
              regSel.value =
                lstRegularizacion.find((r) => r.id == "Si") || null;
            } else {
              regSel.value =
                lstRegularizacion.find((r) => r.id == "No") || null;
            }

            if (solicitud.encabezado.justificacion != null) {
              justSel.value =
                lstJustificacion.find(
                  (j) => j.nombre == solicitud.encabezado.justificacion
                ) || null;
            }

            autorizadorSel.value =
              lstSolicitantes.value.find(
                (s) => s.rut == solicitud.encabezado.autorizadorJustificacion
              ) || null;

            descripOtro.value = solicitud.encabezado.otraJustificacion || "";

            solicitud.detalle.forEach((e: SolicitudDetalle) => {
              if (e.total != null) {
                total.value += e.total;
              }

              if (e.codigoMaterial == "SER-410102") {
                isViveres.value = true;

                if (e.fechaCompra != null) {
                  e.fechaCompra = e.fechaCompra.substr(0, 10);
                }

                if (e.fechaTermino != null) {
                  e.fechaTermino = e.fechaTermino.substr(0, 10);
                }
              } else {
                isViveres.value = false;
              }
            });
          }

          if (tipoSol.value.id == "Rendicion") {
            solicitud.detalle.forEach((e: SolicitudDetalle) => {
              if (e.monto != null) {
                total.value += e.monto;
              }
            });
          }

          for (let i = 0; i < solicitud.detalle.length; i++) {
            if (solicitud.detalle[i].otMantencion != null) {
              let ot = lstAuxNdoc.value.find(
                (a) => a.id == solicitud.detalle[i].otMantencion
              );

              solicitud.detalle[i].otMantencion = ot?.id;
              solicitud.detalle[i].otName = ot?.displayName;
            }

            if (tipoSol.value.id == "Compra") {
              solicitud.detalle[i].total =
                solicitud.detalle[i].cantidad * solicitud.detalle[i].precio;

              solicitud.detalle[i].fechaLimite =
                solicitud.detalle[i].fechaLimite != null
                  ? solicitud.detalle[i].fechaLimite.substr(0, 10)
                  : null;
            }

            if (tipoSol.value.id == "Rendicion") {
              if (solicitud.detalle[i].fechaDoc != null) {
                solicitud.detalle[i].fechaDoc = solicitud.detalle[
                  i
                ].fechaDoc.substr(0, 10);
              }

              if (empresaSel == null) {
                solicitud.detalle[i].cecoId = null;
                solicitud.detalle[i].proyectoId = null;
              }
            }

            // console.log(solicitud.detalle[i]);
            lstDetalle.push(solicitud.detalle[i]);
          }

          detContador = lstDetalle.length + 1;
        }
      })
      .catch((ex) => {
        console.log(ex);
      })
      .finally(() => (isLoading.value = false));
  } catch (error) {
    console.log(error);
  }
}

async function getFiles(idSolicitud: string) {
  try {
    var archivos: Adjunto[] = [];

    await axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetSolicitudFiles?solicitudId=" +
          idSolicitud
      )
      .then((response) => {
        if (response.status == 200) {
          archivos = response.data;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });

    return archivos;
  } catch (error) {
    console.log(error);
  }
}

function bajarAdjunto(filename: string) {
  try {
    isLoading.value = true;

    const link = document.createElement("a");
    link.href =
      store.state.url + "api/SolicitudCompra/DownloadFile?fileName=" + filename;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function guardarSolicitud() {
  try {
    var encab: SolicitudEncabezado = {};
    var detalle: SolicitudDetalle[] = [];

    if (
      solPorId.value == null ||
      solPorId.value == "" ||
      solPorNombre.value == null ||
      solPorNombre.value == ""
    ) {
      swal.fire({
        icon: "warning",
        title: "Debe haber un ingresado por",
        showConfirmButton: true,
      });
      return;
    }

    isLoading.value = true;

    if (tipoSol.value.id == "Compra" || tipoSol.value.id == "Retiro Bodega" || isRespelTipo(tipoSol.value.id)) {
      encab = {
        id: idSolicitud,
        fechaSolicitud: date.value,
        solicitantePorId: solPorId.value,
        solicitantePorNombre: solPorNombre.value,
        companyId: empresaSel.value != null ? empresaSel.value?.id : null,
        departamentoId:
          departamentoSel.value != null ? departamentoSel.value?.id : null,
        observacion: obs.value,
        solicitanteId:
          solicitanteSel.value != null ? solicitanteSel.value?.rut : null,
        solicitanteNombre:
          solicitanteSel.value != null ? solicitanteSel.value?.fullName : null,
        vendorId: vendorSel.value != null ? vendorSel.value?.id : null,
        estado: "Guardada",
        tipoSolicitudId: tipoSol.value.id,
        proyectoId: proyectoSel.value != null ? proyectoSel.value?.id : null,
        comprador: compradorSel.value != null ? compradorSel.value?.code : null,
      };

      // Para Compra, Retiro Bodega, Retiro RESPEL
      if (tipoSol.value.id == "Retiro Bodega" || tipoSol.value.id == "Retiro RESPEL") {
        encab.codigoBodega = codigoBodega.value != null ? codigoBodega.value.id : null;
      } else if (tipoSol.value.id == "Compra") {
        encab.codigoBodega = codigoBodega.value != null ? codigoBodega.value.id : null;
      }

      // Solo Retiro RESPEL guarda codigoDespacho
      if (tipoSol.value.id == "Retiro RESPEL") {
        encab.codigoDespacho = codigoDespacho.value;
      }

      if (tipoSol.value.id == "Compra") {
        if (regSel.value?.id == "Si") {
          encab.solRegularizacion = true;
        } else {
          if (regSel.value?.id == "No") {
            encab.solRegularizacion = false;
          }
        }

        encab.justificacion = justSel.value?.nombre;
        encab.autorizadorJustificacion = autorizadorSel.value?.rut;
        encab.otraJustificacion = descripOtro.value;
        encab.comprador = compradorSel.value?.code;
      }

      // lstDetalle.forEach((e: SolicitudDetalle) => {
      //   if (e.otMantencion != null) {
      //     e.otMantencion = e.otMantencion.id;
      //   }
      // });

      detalle = lstDetalle;

      let solicitud: SolicitudCompra = {
        encabezado: encab,
        detalle: detalle,
      };

      // console.log(JSON.stringify(solicitud));
      enviarSolicitudGuardada(solicitud);
      //}
    } else {
      if (tipoSol.value.id == "Rendicion") {
        encab = {
          id: idSolicitud,
          fechaSolicitud: date.value,
          solicitantePorId: solPorId.value,
          solicitantePorNombre: solPorNombre.value,
          companyId: empresaSel.value != null ? empresaSel.value.id : null,
          departamentoId:
            departamentoSel.value != null ? departamentoSel.value.id : null,
          observacion: obs.value,
          solicitanteId:
            solicitanteSel.value != null ? solicitanteSel.value.rut : null,
          solicitanteNombre:
            solicitanteSel.value != null ? solicitanteSel.value.fullName : null,
          estado: "Guardada",
          fechaLiberacion: fechaLiberacion.value,
          tipoSolicitudId: tipoSol.value.id,
          proyectoId: proyectoSel.value != null ? proyectoSel.value.id : null,
        };

        detalle = lstDetalle;

        for (let i = 0; i < detalle.length; i++) {
          if (departamentoSel != null) {
            detalle[i].deptoId = departamentoSel.value?.id;
          }

          // if (detalle[i].otMantencion != null) {
          //   detalle[i].otMantencion = detalle[i].otMantencion.id;
          // }
        }

        let solicitud: SolicitudCompra = {
          encabezado: encab,
          detalle: detalle,
        };

        // console.log(JSON.stringify(solicitud));
        enviarSolicitudGuardada(solicitud);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function enviarSolicitudGuardada(solicitud: SolicitudCompra) {
  isLoading.value = true;

  axios
    .post(
      store.state.url + "api/SolicitudCompra/PostSolicitudCompraGuardada",
      solicitud
    )
    .then(async (response) => {
      if (response.status == 200) {
        if (file.value.length > 0) {
          await submitFile(solicitud);
        }

        date.value = new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);

        swal.fire({
          icon: "success",
          title: "Solicitud Guardada Exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        router.push({
          name: "BuscaSolicitud",
        });
      } else {
        const t = translateBcError(response.statusText); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al guardar la solicitud",
          text: t.message,
          showConfirmButton: true,
        });
      }
    })
    .catch((error) => {
      // errorMessage = error.message;
      const t = translateBcError(error.message);

      swal.fire({
        icon: "error",
        title: "Error al guardar la solicitud",
        text: t.message,
        showConfirmButton: true,
      });
    })
    .finally(() => (isLoading.value = false));
}

async function crearSolicitud() {
  try {
    if (file.value.length > 0) {
      let totalSize = 0;
      file.value.forEach((f) => {
        totalSize += f.size;
      });

      if (totalSize > 200 * 1024 * 1024) {
        swal.fire({
          icon: "warning",
          title: "El tamaño de los archivos no puede superar los 200MB",
          showConfirmButton: true,
        });
        return;
      }
    }

    if (tipoSol.value == null) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un tipo de solicitud",
        showConfirmButton: true,
      });
      return;
    }

    if (empresaSel.value == null) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar una empresa",
        showConfirmButton: true,
      });
      return;
    }

    if (departamentoSel.value == null) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un departamento",
        showConfirmButton: true,
      });
      return;
    }

    if (!isRespelTipo(tipoSol.value.id) && solicitanteSel.value == null) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un Solicitante",
        showConfirmButton: true,
      });
      return;
    }

    if (lstDetalle.length == 0) {
      swal.fire({
        icon: "warning",
        title: "Debe agregar al menos un material",
        showConfirmButton: true,
      });
      return;
    }

    if (lstDetalle.some((x) => x.cecoId == null)) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un ceco",
        showConfirmButton: true,
      });
      return;
    }

    if (!isRespelTipo(tipoSol.value.id) && lstDetalle.some((x) => x.proyectoId == null)) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un proyecto",
        showConfirmButton: true,
      });
      return;
    }

    if (
      solPorId.value == null ||
      solPorId.value == "" ||
      solPorNombre.value == null ||
      solPorNombre.value == ""
    ) {
      swal.fire({
        icon: "warning",
        title: "Debe haber un ingresado por",
        showConfirmButton: true,
      });
      return;
    }

    var encab: SolicitudEncabezado = {};
    var detalle: SolicitudDetalle[] = [];

    isLoading.value = true;

    if (tipoSol.value.id == "Compra" || tipoSol.value.id == "Retiro Bodega" || isRespelTipo(tipoSol.value.id)) {
      if (lstDetalle.some((x) => x.cantidad == 0)) {
        swal.fire({
          icon: "warning",
          title: "Debe ingresar una cantidad mayor a 0",
          showConfirmButton: true,
        });
        return;
      }

      if (tipoSol.value.id == "Retiro Bodega") {
        if (codigoBodega == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar una bodega",
            showConfirmButton: true,
          });
          return;
        }

        // //si existe un item con inventario 0 o negativo, mostrar alerta
        // if (
        //   lstDetalle.some((x) => x.inventario != null && x.inventario! <= 0)
        // ) {
        //   swal.fire({
        //     icon: "warning",
        //     title:
        //       "Material con inventario en 0 o en negativo. No se pueden solicitar materiales que no cuenten con stock",
        //     showConfirmButton: true,
        //   });
        //   return;
        // }

        // //si la cantidad a retirar es mayor al inventario, mostrar alerta
        // if (
        //   lstDetalle.some(
        //     (x) =>
        //       x.cantidad != null &&
        //       x.inventario != null &&
        //       x.cantidad! > x.inventario!
        //   )
        // ) {
        //   swal.fire({
        //     icon: "warning",
        //     title:
        //       "Cantidad es mayor a stock de inventario. No se puede solicitar una cantidad mayor al stock disponible",
        //     showConfirmButton: true,
        //   });
        //   return;
        // }
      }

      encab = {
        id: idSolicitud,
        fechaSolicitud: date.value,
        solicitantePorId: solPorId.value,
        solicitantePorNombre: solPorNombre.value,
        companyId: empresaSel.value?.id,
        departamentoId: departamentoSel.value?.id,
        observacion: obs.value,
        solicitanteId: solicitanteSel.value?.rut,
        solicitanteNombre: solicitanteSel.value?.fullName,
        estado: "Creada",
        tipoSolicitudId: tipoSol.value.id,
        ...(tipoSol.value.id === "Retiro RESPEL" && { codigoDespacho: codigoDespacho.value }),
        proyectoId: proyectoSel != null ? proyectoSel.value?.id : null,
      };

      detalle = lstDetalle;

      if (tipoSol.value.id == "Compra") {

          var roles = await getRol(cookies.get("username"));
          if (roles != null && roles.some((r: Rol) => r.rolNombre === "Comprador")) {
            esComprador.value = true;
          } else {
            esComprador.value = false;
          }

        if (vendorSel == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (compradorSel == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un comprador",
            showConfirmButton: true,
          });
          return;
        }

        // // // encab.vendorId = vendorSel != null ? vendorSel.value?.id : null;
        // // // encab.comprador = compradorSel.value?.code;

        if (
          regSel.value?.id == "Si" &&
          justSel.value?.id == 7 &&
          descripOtro.value == null
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar una descripción",
            showConfirmButton: true,
          });
          return;
        }

        encab.vendorId = vendorSel != null ? vendorSel.value?.number : null;
        encab.comprador = compradorSel.value?.code;

        if (regSel.value.id == "Si") {
          encab.solRegularizacion = true;
        } else {
          if (regSel.value.id == "No") {
            encab.solRegularizacion = false;
          }
        }

        for (let i = 0; i < detalle.length; i++) {

          if (
            detalle[i].codigoMaterial != null &&
            detalle[i].codigoMaterial?.includes("MAT-") &&
            !esComprador.value
          ) {
              swal.fire({
                icon: "warning",
                html:
                  '<span style="font-size:18px">Estimado(a),<br>Se informa que solo el área de Adquisiciones puede generar solicitudes de compra con código MAT.<br>Usted puede crear solicitudes de compra con todos los demás códigos habilitados.<br>Para más información, favor contactar a Adquisiciones.</span>',
                showConfirmButton: true,
              });
            return;
          }

          if (
            detalle[i].codigoMaterial?.includes("MAT-") &&
            detalle[i].codigoBodega == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Se debe seleccionar bodega para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].tripulanteId == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar un tripulante para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].turnoId == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar un turno para el item " + detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          //validar que fecha compra sea una fecha valida con regex y el format "dd-MM-yyyy"
          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaCompra != null
          ) {
            let regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(detalle[i].fechaCompra ?? "")) {
              swal.fire({
                icon: "warning",
                title: "La fecha de compra debe tener el formato dd-MM-yyyy",
                showConfirmButton: true,
              });
              return;
            }
          }

          //validar que fecha termino sea una fecha valida con regex y el format "dd-MM-yyyy"
          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaTermino != null
          ) {
            let regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(detalle[i].fechaTermino ?? "")) {
              swal.fire({
                icon: "warning",
                title: "La fecha de término debe tener el formato dd-MM-yyyy",
                showConfirmButton: true,
              });
              return;
            }
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaCompra != null &&
            detalle[i].fechaTermino != null
          ) {
            if (
              new Date(detalle[i].fechaCompra ?? "") >
              new Date(detalle[i].fechaTermino ?? "")
            ) {
              swal.fire({
                icon: "warning",
                title:
                  "La fecha de término debe ser mayor a la fecha de compra",
                showConfirmButton: true,
              });
              return;
            }
          }

          if (/*regSel.value?.id == "Si" &&*/ detalle[i].fechaLimite == null) {
            swal.fire({
              icon: "warning",
              title: "Debe seleccionar una fecha límite",
              showConfirmButton: true,
            });
            return;
          }

          if (
            /*regSel.value?.id == "Si" &&*/
            detalle[i].fechaLimite != null &&
            new Date(detalle[i].fechaLimite ?? "") <= new Date(date.value ?? "")
          ) {
            swal.fire({
              icon: "warning",
              title:
                "La fecha límite no puede ser menor a la fecha de solicitud",
              showConfirmButton: true,
            });
            return;
          }

          if (
            /*route.params.solicitudId*/ idSol.value != undefined ||
            /*route.params.solicitudId*/ idSol.value != null
          ) {
            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
            detalle[i].codigoBodega = detalle[i].codigoBodega;
          }

          // if (detalle[i].otMantencion != null) {
          //   detalle[i].otMantencion = detalle[i].otMantencion.id || null;
          // }
        }
      }

      if (tipoSol.value.id == "Retiro Bodega") {
        if (codigoBodega.value == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar una bodega",
            showConfirmButton: true,
          });
          return;
        }

        encab.codigoBodega =
          codigoBodega.value != null ? codigoBodega.value.id : null;

        if (idSol.value != undefined || idSol.value != null) {
          encab.codigoBodega =
            codigoBodega != null ? codigoBodega.value?.id : null;

          for (let i = 0; i < detalle.length; i++) {
            if (
              detalle[i].codigoMaterial == "MAT-001552" &&
              (detalle[i].numSerie == null ||
                detalle[i].numSerie == "" ||
                detalle[i].numSerie == undefined)
            ) {
              swal.fire({
                icon: "warning",
                title:
                  "Se debe ingresar el número de serie para el item " +
                  detalle[i].material,
                showConfirmButton: true,
              });
              return;
            }

            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
          }
        }
      }

      for (let i = 0; i < detalle.length; i++) {
        // if (
        //   empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" &&
        //   detalle[i].codigoMaterial?.includes("CON-") &&
        //   detalle[i].codigoMaterial != "CON-000416" &&
        //   detalle[i].codigoMaterial != "CON-000417" &&
        //   detalle[i].codigoMaterial != "CON-000418" &&
        //   detalle[i].codigoMaterial != "CON-000415"
        // ) {
        //   let cecoSeleccionado = lstCeco.value.find(
        //     (c) => c.id == detalle?.[i]?.cecoId
        //   )?.code;

        //   // if (
        //   //   !cecoSeleccionado?.startsWith("1") &&
        //   //   !cecoSeleccionado?.startsWith("3") &&
        //   //   regSel.value?.id == "No"
        //   // ) {
        //   //   console.log(cecoSeleccionado?.startsWith("1"));
        //   //   console.log(cecoSeleccionado?.startsWith("3"));
        //   //   swal.fire({
        //   //     icon: "warning",
        //   //     title:
        //   //       "ítems de tipo consumo deben solicitarse por la empresa 19 - TMO Acuicola S.A",
        //   //     showConfirmButton: true,
        //   //   });
        //   //   return;
        //   // }

        //   if (!validarCecoYEmpresa(cecoSeleccionado, regSel)) {
        //     return; // Cortas el flujo si no cumple
        //   }
        // }

        var validCantidad = currency(String(detalle[i].cantidad ?? 0), {
          decimal: ",",
          errorOnInvalid: true,
        });

        if (isNaN(validCantidad.value)) {
          swal.fire({
            icon: "warning",
            title: "La cantidad no es válida",
            showConfirmButton: true,
          });
          return;
        }

        detalle[i].cantidad = validCantidad.value;

        if (detalle[i].precio == null) {
          detalle[i].precio = 0;
        }

        // if (detalle[i].otMantencion != null)
        //   detalle[i].otMantencion = detalle[i].otMantencion.id || null;
      }

      let solicitud: SolicitudCompra = {
        encabezado: encab,
        detalle: detalle,
      };

      if (isIngresoRespel(tipoSol.value.id)) {
        for (const d of detalle) {
          if (d.tipoResiduo == null) {
            swal.fire({
              icon: "warning",
              title: "Debe seleccionar un tipo de residuo para el material " + d.material,
              showConfirmButton: true,
            });
            isLoading.value = false;
            return;
          }
          d.deptoId = departamentoSel.value?.id;
        }
      }

      if (tipoSol.value.id == "Retiro RESPEL") {
        for (const d of detalle) {
          d.deptoId = departamentoSel.value?.id;
        }
      }

      // if (tipoSol.value.id == "Compra") {
      //   validarPresupuesto(solicitud);
      // } else {
      //   console.log(JSON.stringify(solicitud));
      //   enviarSolicitud(solicitud);
      // }

      //console.log(JSON.stringify(solicitud));
      enviarSolicitud(solicitud);
    } else {
      if (tipoSol.value.id == "Rendicion") {
        if (lstDetalle.some((x) => x.tipoDoc == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un tipo de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.fechaDoc == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar una fecha de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) =>
              x.nroDoc == null &&
              x.tipoDoc != "Sin Documento" &&
              x.tipoDoc != "Vale"
          )
        ) {
          loading = false;

          swal.fire({
            icon: "warning",
            title: "Debe ingresar un numero de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) => x.proveedorId == null && x.tipoDoc == "Factura"
          )
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) => x.proveedorId == null && x.tipoDoc == "B. Honorarios"
          )
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.descGasto == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar una descripción del gasto",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.monto == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar un monto",
            showConfirmButton: true,
          });
          return;
        }

        encab = {
          id: idSolicitud,
          fechaSolicitud: date.value,
          solicitantePorId: solPorId.value,
          solicitantePorNombre: solPorNombre.value,
          companyId: empresaSel.value?.id,
          departamentoId: departamentoSel.value?.id,
          observacion: obs.value,
          solicitanteId: solicitanteSel.value?.rut,
          solicitanteNombre: solicitanteSel.value?.fullName,
          estado: "Creada",
          fechaLiberacion: fechaLiberacion.value,
          tipoSolicitudId: tipoSol.value?.id,
        };

        detalle = lstDetalle;

        for (let i = 0; i < detalle.length; i++) {
          detalle[i].deptoId = departamentoSel.value?.id;

          // if (detalle[i].otMantencion != null)
          //   detalle[i].otMantencion = detalle[i].otMantencion.id || null;
        }

        let solicitud: SolicitudCompra = {
          encabezado: encab,
          detalle: detalle,
        };

        // console.log(JSON.stringify(solicitud));
        await enviarSolicitud(solicitud);
      }
    }
  } catch (error) {
    console.log(error);
    swal.fire({
      icon: "error",
      title: "Error al crear solicitud",
      text: error instanceof Error ? error.message : "Error desconocido",
      showConfirmButton: true,
    });
  } finally {
    isLoading.value = false;
  }
}

async function enviarSolicitud(solicitud: SolicitudCompra): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    axios
      .post(
        store.state.url + "api/SolicitudCompra/PostSolicitudCompra",
        solicitud
      )
      .then(async (response) => {
        if (response.status == 200) {
          if (file.value.length > 0) {
            await submitFile(solicitud);
          }

          date.value = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);

          empresaSel.value = null;
          departamentoSel.value = null;
          vendorSel.value = null;
          solicitanteSel.value = null;
          obs.value = "";

          lstItems.value = [];
          file.value = [];

          detContador = 1;

          swal.fire({
            icon: "success",
            title: "Solicitud Creada Exitosamente",
            showConfirmButton: false,
            timer: 2000,
          });

          if (cookies.get("username") != "") {
            obtenerEmpleado(cookies.get("username"));
          }

          await sendEmail(solicitud.encabezado.id);

          router.push({
            name: "BuscaSolicitud",
          });

          resolve();
        } else {
          const t = translateBcError(response.statusText);

          swal.fire({
            icon: "error",
            title: "Error al guardar la solicitud",
            text: t.message,
            showConfirmButton: true,
          });

          reject(new Error(t.message));
        }
      })
      .catch((error) => {
        const t = translateBcError(error.message);

        swal.fire({
          icon: "error",
          title: "Error al guardar la solicitud",
          text: t.message,
          showConfirmButton: true,
        });

        reject(error);
      });
  });
}

async function submitFile(solicitud: SolicitudCompra) {
  const files = new FormData();

  for (let i = 0; i < file.value.length; i++) {
    files.append("files", file.value[i]);
  }

  const headers = { "Content-Type": "multipart/form-data" };

  await axios
    .post(
      store.state.url +
        "api/SolicitudCompra/UploadMultipleFile?solid=" +
        solicitud.encabezado.id +
        "&company=" +
        solicitud.encabezado.companyId,
      files,
      {
        headers,
      }
    )
    .then(async (res) => {
      if (res.status == 200) {
        await postFiles(res.data, solicitud.encabezado.id);
      } else {
        console.log("Error al cargar archivo, status code:" + res.status);
      }
    })
    .finally(() => (isLoading.value = false));
}

async function postFiles(files: File, solId: string | undefined) {
  await axios
    .post(
      store.state.url + "api/SolicitudCompra/PostFiles?solicitudId=" + solId,
      files,
      { headers: {} }
    )
    .then((response) => {
      if (response.status == 200) {
        console.log("Archivos subidos correctamente");
      } else {
        console.log(response.statusText);
      }
    })
    .catch(function (error) {
      console.log(error.message);
    });
}

async function sendEmail(idSol: string | undefined) {
  try {
    // await refreshToken()
    //   .then(async () => {
    //     var token = cookies.get("token");

    await axios
      .post(store.state.url + "api/SolicitudCompra/SendEmail?idSol=" + idSol)
      .then((response) => {
        if (response.status == 200) {
          const recipients: string[] = response.data?.recipients || [];
          const message: string = response.data?.message || "Resultado de envío sin mensaje.";
          console.log("[Email]", message, "Destinatarios:", recipients.join(", "));
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    // })
    // .catch((error: any) => {
    //   console.log(error);
    // });
  } catch (error) {
    console.log(error);
  }
}

async function verificarUsuario(
  tipo: string,
  depto: string,
  solPorId: string,
  solId: string
) {
  let verificado = false;

  await obtenerEmpleado(cookies.get("username"));
  // await this.obtenerEmpleado("czambrano@oxxeanchile.cl");

  var roles = await getRol(cookies.get("username"));
  // var roles = await this.getRol("czambrano@oxxeanchile.cl");

  if (roles != null && roles.some((r) => r.rolNombre === "Administrador")) {
    return true;
  }

  if (usuario != null && usuario.value?.rut == solId) {
    return true;
  }

  if (usuario != null && usuario.value?.rut == solPorId) {
    return true;
  }

  if (
    tipo == "Compra" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Comprador")
  ) {
    verificado = true;
  }

  if (
    tipo == "Retiro Bodega" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Bodega")
  ) {
    verificado = true;
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Contabilidad")
  ) {
    verificado = true;
  }

  if (
    (tipo == "Compra" || tipo == "Retiro Bodega") &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Visualizador")
  ) {
    let deptosViusalizador = await getDeptosRol(
      cookies.get("username"),
      // "czambrano@oxxeanchile.cl",
      "Visualizador"
    );

    if (deptosViusalizador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Autorizador")
  ) {
    let deptosAutorizador = await getDeptosRol(
      cookies.get("username"),
      // "czambrano@oxxeanchile.cl",
      "Autorizador"
    );

    if (deptosAutorizador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  if (
    tipo == "Rendicion" &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Visor Rendiciones")
  ) {
    verificado = true;
  }

  if (
    (tipo == "Compra" || tipo == "Retiro Bodega") &&
    roles != null &&
    roles.some((r) => r.rolNombre === "Aprobador")
  ) {
    let deptosAprobador = await getDeptosRol(
      (roles != null && cookies.get("username")) || "",
      // "czambrano@oxxeanchile.cl",
      "Aprobador"
    );

    if (deptosAprobador?.some((d) => d == depto)) {
      verificado = true;
    }
  }

  return verificado;
}

async function getDeptosRol(email: string, rol: string) {
  try {
    var deptos: string[] = [];

    await axios
      .get(
        store.state.url + "api/Rol/GeDeptostRol?email=" + email + "&rol=" + rol,
        {
          headers: {},
        }
      )
      .then((response) => {
        if (response.status == 200) {
          deptos = response.data;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });

    return deptos;
  } catch (error) {
    console.log(error);
  }
}

async function getRol(email: string) {
  try {
    var tiene: Rol[] = [];

    await axios
      .get(store.state.url + "api/Rol/GetRol?email=" + email, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          tiene = response.data as Rol[];
        } else {
          console.log(response.statusText);
          tiene = [];
        }
      })
      .catch(function (error) {
        console.log(error.message);
        tiene = [];
      });

    return tiene;
  } catch (error) {
    console.log(error);
  }
}

async function addFiles() {
  for (var f of selectedFiles.value) {
    if (f.size > 5242880) {
      swal.fire({
        icon: "warning",
        title: "El archivo " + f.name + " no puede superar los 5 MB",
        showConfirmButton: true,
      });

      const index = selectedFiles.value.indexOf(f);
      if (index > -1) {
        selectedFiles.value.splice(index, 1);
      }
    } else {
      file.value.push(f);
    }
  }

  selectedFiles.value = [];
}

function rendicionTotal() {
  total.value = lstDetalle.reduce((acc, item) => acc + Number(item.monto ?? 0), 0);
}

async function cambioRetBodega() {
  if (tipoSol.value?.id == "Retiro Bodega") {
    for (var detRet of lstDetalle) {
      detRet.retiroBodega = true;
    }

    regSel.value = null;
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;

    // Recargar bodegas según tipo y empresa seleccionada
    if (empresaSel.value != null) {
      await getBodegas(empresaSel.value.id);
      if (
        codigoBodega.value != null &&
        !lstBodegas.value.some((b) => b.id === (codigoBodega.value as any).id)
      ) {
        codigoBodega.value = null;
      }
    }
  } else if (isRespelTipo(tipoSol.value?.id)) {
    // Para tipos RESPEL, limpiar campos de regularización
    regSel.value = null;
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;
    // Recargar solo bodegas RESPEL si hay empresa
    if (empresaSel.value != null) {
      await getBodegasResiduo(empresaSel.value.id);
      if (
        codigoBodega.value != null &&
        !lstBodegas.value.some((b) => b.id === (codigoBodega.value as any).id)
      ) {
        codigoBodega.value = null;
      }
    }
  } else {
    if (tipoSol.value?.id == "Rendicion") {
      regSel.value = null;
      justSel.value = null;
      autorizadorSel.value = null;
      descripOtro.value = null;
    }

    // await getCompanies(solPorId.value || "", "");

    for (var det of lstDetalle) {
      det.retiroBodega = false;
    }
  }
}

async function selectCompany() {
  try {
    if (localStorage.getItem("empresa") != null) {
      await swal
        .fire({
          icon: "warning",
          title: "Se perderán los datos ingresados, ¿Desea continuar?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          allowOutsideClick: false,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            isLoading.value = true;
            if (
              typeof empresaSel.value != "string" &&
              empresaSel.value != null
            ) {
              localStorage.setItem("empresa", JSON.stringify(empresaSel.value));

              departamentoSel.value = null;
              vendorSel.value = null;
              solicitanteSel.value = null;
              // lstDetalle = [];

              await getDepartamentos(empresaSel.value.id, solPorId.value);
              await getCeco(empresaSel.value.id);
              await getBodegas(empresaSel.value.id);
              await getVendors(empresaSel.value.id);
              await getProyectos(empresaSel.value.id, solPorId.value);
              await getCompradores(empresaSel.value.id);
              await getAuxNdoc(empresaSel.value.id);

              if (
                empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
                empresaSel.value.name == "19 - TMO Acuicola S.A" ||
                empresaSel.value.name == "25 Consorcio De Proyectos Marí"
              ) {
                await getTripulantes(empresaSel.value.id);
                await getTurnos(empresaSel.value.id);
              }
            }
          } else {
            empresaSel.value = JSON.parse(
              localStorage.getItem("empresa") || ""
            );
          }
        });
    } else {
      localStorage.setItem("empresa", JSON.stringify(empresaSel.value));

      await getDepartamentos(empresaSel.value?.id || "", solPorId.value);
      await getCeco(empresaSel.value?.id || "");
      await getBodegas(empresaSel.value?.id || "");
      await getVendors(empresaSel.value?.id || "");
      await getProyectos(empresaSel.value?.id || "", solPorId.value);
      await getCompradores(empresaSel.value?.id || "");
      await getAuxNdoc(empresaSel.value?.id || "");

      if (
        empresaSel.value?.name == "18 - Trab. Marítimos Oxxean SA" ||
        empresaSel.value?.name == "19 - TMO Acuicola S.A" ||
        empresaSel.value?.name == "25 Consorcio De Proyectos Marí"
      ) {
        await getTripulantes(empresaSel.value.id);
        await getTurnos(empresaSel.value.id);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

function cambioRegJustificacion() {
  if (regSel.value?.id == "No") {
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;
  }
}

function cambioJustificacion() {
  if (justSel.value?.id == 5 || justSel.value?.id == 7) {
    if (justSel.value?.id == 5) {
      descripOtro.value = null;
    }

    if (justSel.value?.id == 7) {
      autorizadorSel.value = null;
    }
  } else {
    autorizadorSel.value = null;
    descripOtro.value = null;
  }
}

function setIcon(fileName: string) {
  try {
    var icon = "";

    var ext = fileName.substring(fileName.lastIndexOf(".") + 1);

    switch (ext) {
      case "pdf":
        icon = "mdi-file-pdf-box";
        break;

      case "doc":
        icon = "mdi-file-word";
        break;

      case "docx":
        icon = "mdi-file-word";
        break;

      case "xls":
        icon = "mdi-file-excel";
        break;

      case "xlsx":
        icon = "mdi-file-excel";
        break;

      case "ppt":
        icon = "mdi-file-powerpoint";
        break;

      case "pptx":
        icon = "mdi-file-powerpoint";
        break;

      case "jpeg":
        icon = "mdi-file-image";
        break;

      case "png":
        icon = "mdi-file-image";
        break;

      case "gif":
        icon = "mdi-file-image";
        break;

      case "jpg":
        icon = "mdi-file-image";
        break;

      case "7z":
        icon = "mdi-zip-box";
        break;

      case "rar":
        icon = "mdi-zip-box";
        break;

      case "zip":
        icon = "mdi-zip-box";
        break;

      case "txt":
        icon = "mdi-file-document";
        break;

      default:
        icon = "mdi-file";
        break;
    }

    return icon;
  } catch (error) {
    console.log(error);
  }
}

function sliceString(value: string) {
  return value.substring(value.lastIndexOf("/") + 1);
}

function formatMoney(value: number) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    minimumFractionDigits: 2,
  }).format(value);
}

function filterNumber(evt: any) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();

  if (!/^[0-9]*\.?[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function formatTotal(value: number | null): string {
  if (value == null) {
    return "";
  }
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
}

function filterOnlyNumber(evt: any) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();

  //solo numeros
  if (!/^[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function calcularTotalCantidad(item: SolicitudDetalle) {
  const precioStr = String(item.precio ?? "").replace(/,/g, "").replace(/\./g, "");
  const cantidadStr = String(item.cantidad ?? "").replace(/,/g, ".");

  const precioNum = precioStr === "" ? 0 : Number(precioStr);
  const cantidadNum = cantidadStr === "" ? 0 : Number(cantidadStr);

  item.precio = precioNum;
  item.cantidad = cantidadNum;
  item.total = precioNum * cantidadNum;
  compraTotal();
}

function compraTotal() {
  total.value = lstDetalle.reduce((acc, item) => acc + Number(item.total ?? 0), 0);
}

function showDeleteDialog(item: SolicitudDetalle) {
  itemToDelete = item;
  dialogDelete.value = !dialogDelete.value;
}

function deleteMaterial(item: SolicitudDetalle) {
  //const index = lstDetalle.values.indexOf(item);
  let index = lstDetalle.findIndex((x) => x.id == item.id);
  lstDetalle.splice(index, 1);

  dialogDelete.value = !dialogDelete;

  for (let i = 0; i < lstDetalle.length; i++) {
    lstDetalle[i].id = i + 1;
  }

  detContador = lstDetalle.length + 1;
}

function validarCecoYEmpresa(
  cecoSeleccionado: string | undefined,
  regSel: Regularizacion | null
  // regSel: { value?: { id?: string } }
) {
  if (!cecoSeleccionado) {
    swal.fire({
      icon: "error",
      title: "Centro de costo no definido",
      text: "Debes seleccionar un centro de costo.",
      showConfirmButton: true,
    });
    return false;
  }

  const empiezaCon1 = cecoSeleccionado.startsWith("1");
  const empiezaCon3 = cecoSeleccionado.startsWith("3");
  const idEsNo = regSel?.id == "No" ? true : false;

  // Validación general: Ceco no permitido (no empieza ni con 1 ni con 3)
  if (!empiezaCon1 && !empiezaCon3) {
    swal.fire({
      icon: "error",
      title: "Centro de costo inválido",
      text: "El centro de costo debe comenzar con 1 o 3.",
      showConfirmButton: true,
    });
    return false;
  }

  // Validación por empresa
  if ((empiezaCon1 || empiezaCon3) && idEsNo) {
    swal.fire({
      icon: "warning",
      title: "Empresa inválida",
      text: "Ítems de tipo consumo deben solicitarse por la empresa 19 - TMO Acuicola S.A",
      showConfirmButton: true,
    });
    return false;
  }

  return true; // Todo está OK
}

function obtenerTiposSolicitud(rut: string, currentTipoId?: string) {
  try {
    axios
      .get(
        store.state.url + "api/SolicitudCompra/GetTipoSolicitudes?rut=" + rut
      )
      .then((response) => {
        if (response.status == 200) {
          lstTipoSolicitud = response.data as TipoSolicitud[];
          if (lstTipoSolicitud.length > 0) {
            const found = currentTipoId
              ? lstTipoSolicitud.find((t) => t.id === currentTipoId)
              : null;
            tipoSol.value = found ?? lstTipoSolicitud[0];
          }
        } else {
          const t = translateBcError(response.statusText); // { message, correlationId, key }
          console.error(response.statusText);

          swal.fire({
            icon: "error",
            title: "Error al obtener los tipos de solicitud",
            text: t.message,
            showConfirmButton: true,
          });
        }
      })
      .catch((error) => {
        const t = translateBcError(error.message); // { message, correlationId, key }
        console.error(error.message);

        swal.fire({
          icon: "error",
          title: "Error al obtener los tipos de solicitud",
          text: t.message,
          showConfirmButton: true,
        });
      });
  } catch (error) {
    console.log(error);
  }
}

function generarMesesServicio(
  cantidadMeses: number,
  fechaInicio = new Date()
): MesServicio[] {
  const lista: MesServicio[] = [];

  const anioInicio = fechaInicio.getFullYear();
  const mesInicio = fechaInicio.getMonth(); // 0 = enero, 11 = diciembre

  for (let i = 0; i < cantidadMeses; i++) {
    const fecha = new Date(anioInicio - 1, mesInicio + i, 1); // suma meses y deja que Date maneje el cambio de año
    const anio = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0"); // "01".."12"

    const valor = `${anio}-${mes}`;
    lista.push({
      id: valor,
      nombre: valor,
    });
  }

  return lista;
}

// function validarPresupuesto(solicitud: SolicitudCompra): boolean {
//   let validado: boolean = true;

//   solicitud.detalle.forEach(async (det) => {
//     if (det.tienePresup) {
//       if (det.mesServicio == "2024-12") {
//         swal.fire({
//           icon: "warning",
//           title:
//             "El " +
//             det.material +
//             " no tiene presupuesto para el mes de diciembre del 2024",
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       if (det.cecoId == null) {
//         swal.fire({
//           icon: "warning",
//           title: "Debe seleccionar un ceco para el item " + det.material,
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       if (det.proyectoId == null) {
//         swal.fire({
//           icon: "warning",
//           title: "Debe seleccionar un proyecto para el item " + det.material,
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       if (det.concepto == null) {
//         swal.fire({
//           icon: "warning",
//           title: "Debe seleccionar un concepto para el item " + det.material,
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       let currPrep: number;

//       var depto = lstDepartamento.value.find(
//         (d) => d.id == departamentoSel.value?.id
//       );

//       var ceco = lstCeco.value.find((c) => c.id == det.cecoId);

//       var proyecto = lstProyectos.value.find((p) => p.id == det.proyectoId);

//       if (depto?.code && det.concepto && ceco?.code && proyecto?.displayName) {
//         await getPresupuesto(
//           depto.code,
//           det.concepto,
//           ceco.code,
//           proyecto?.displayName
//         ).then(async (response) => {
//           var presupuesto = response as Presupuesto;

//           if (!presupuesto) {
//             swal.fire({
//               icon: "warning",
//               title: "No se encontró presupuesto para el item " + det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }

//           switch (det.mesServicio) {
//             case "2025-01":
//               currPrep = presupuesto.enero_2025 || 0;
//               break;
//             case "2025-02":
//               currPrep = presupuesto.febrero_2025 || 0;
//               break;
//             case "2025-03":
//               currPrep = presupuesto.marzo_2025 || 0;
//               break;
//             case "2025-04":
//               currPrep = presupuesto.abril_2025 || 0;
//               break;
//             case "2025-05":
//               currPrep = presupuesto.mayo_2025 || 0;
//               break;
//             case "2025-06":
//               currPrep = presupuesto.junio_2025 || 0;
//               break;
//             case "2025-07":
//               currPrep = presupuesto.julio_2025 || 0;
//               break;
//             case "2025-08":
//               currPrep = presupuesto.agosto_2025 || 0;
//               break;
//             case "2025-09":
//               currPrep = presupuesto.septiembre_2025 || 0;
//               break;
//             case "2025-10":
//               currPrep = presupuesto.octubre_2025 || 0;
//               break;
//             case "2025-11":
//               currPrep = presupuesto.noviembre_2025 || 0;
//               break;
//             case "2025-12":
//               currPrep = presupuesto.diciembre_2025 || 0;
//               break;
//             default:
//               currPrep = 0;
//               break;
//           }

//           if (currPrep >= 0) {
//             swal.fire({
//               icon: "warning",
//               title:
//                 "El item " +
//                 det.material +
//                 " excede el presupuesto disponible del material " +
//                 det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }

//           if ((det.total ?? 0) > currPrep * -1) {
//             swal.fire({
//               icon: "warning",
//               title:
//                 "El item " +
//                 det.material +
//                 " excede el presupuesto disponible del material " +
//                 det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }
//         });
//       }

//       if (!validado) {
//         return false;
//       }

//       enviarSolicitud(solicitud);
//       return true;
//     }
//   });

//   return false;
// }
</script>
